import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fc73cff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report bg-white relative" }
const _hoisted_2 = { class: "header w-full text-right fixed relative hidden" }
const _hoisted_3 = { class: "body text-left h-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-data" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold inline-block" }, "Report dipendenti"),
  /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-900" }, "Scarica i relativi report dei dipendenti selezionati"),
  /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 gap-4" })
], -1))
const _hoisted_5 = { class: "documents absolute margin-x-auto w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChatIcon = _resolveComponent("ChatIcon")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_DownloadReportDialog = _resolveComponent("DownloadReportDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PrimaryButton, { class: "bg-primary-100 chat-button text-primary" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChatIcon, { class: "icon" }),
          _createTextVNode("Chat")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_PrimaryButton, {
          class: "mb-0 bg-primary-900 text-white m-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadSelectedReport()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Scarica Report")
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.downloadReport)
      ? (_openBlock(), _createBlock(_component_DownloadReportDialog, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDownloadReportDialog()))
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ]))
}